import { Instrutor, Alocacao, AvaliacaoPendenteResponse, ProdutividadeDocenteItem } from '../models/instrutoria.model';

export const INSTRUTORES_MOCK: Instrutor[] = [
  {
    id: 'f87a8b23-149b-4395-8ef6-15e8d5f47001',
    servidorId: '768ea211-1a6c-48be-8a21-998dc711a001',
    matriculaPm: '100.123-4',
    nomeCompleto: '1º TEN QOPM LUCAS FERREIRA',
    postoGraduacao: '1º TENENTE',
    unidadeNome: 'CFAP / CEP',
    habilitacoes: [
      {
        id: 'hab-001',
        areaInstrucao: 'Tiro Policial',
        cursoCfiId: 'cfi-001',
        validade: '2025-09-30',
        estado: 'ATIVA'
      },
      {
        id: 'hab-002',
        areaInstrucao: 'Defesa Pessoal',
        cursoCfiId: 'cfi-002',
        validade: '2025-03-15',
        estado: 'ATIVA'
      },
      {
        id: 'hab-003',
        areaInstrucao: 'Armamento e Tiro',
        cursoCfiId: 'cfi-003',
        validade: '2025-11-10',
        estado: 'ATIVA'
      },
      {
        id: 'hab-004',
        areaInstrucao: 'Direção Defensiva',
        cursoCfiId: 'cfi-004',
        validade: '2024-03-01',
        estado: 'EXPIRADA'
      }
    ],
    estado: 'ATIVO',
    avaliacaoMedia: 4.9,
    totalHorasMinistradas: 564,
    criadoEm: '2026-05-19T10:00:00Z'
  },
  {
    id: 'f87a8b23-149b-4395-8ef6-15e8d5f47002',
    servidorId: '768ea211-1a6c-48be-8a21-998dc711a002',
    matriculaPm: '100.456-7',
    nomeCompleto: 'CAP QOPM BRUNO ALMEIDA',
    postoGraduacao: 'CAPITÃO',
    unidadeNome: 'DEC - Departamento de Ensino e Cultura',
    habilitacoes: [
      {
        id: 'hab-005',
        areaInstrucao: 'Direito e Legislação',
        cursoCfiId: 'cfi-005',
        validade: '2026-12-31',
        estado: 'ATIVA'
      },
      {
        id: 'hab-006',
        areaInstrucao: 'Gestão e Liderança',
        cursoCfiId: 'cfi-006',
        validade: '2026-08-15',
        estado: 'ATIVA'
      }
    ],
    estado: 'ATIVO',
    avaliacaoMedia: 4.8,
    totalHorasMinistradas: 512,
    criadoEm: '2026-05-20T08:30:00Z'
  },
  {
    id: 'f87a8b23-149b-4395-8ef6-15e8d5f47003',
    servidorId: '768ea211-1a6c-48be-8a21-998dc711a003',
    matriculaPm: '101.789-0',
    nomeCompleto: 'MAJ QOPM DANIEL MARTINS',
    postoGraduacao: 'MAJOR',
    unidadeNome: 'APMB - Academia de Polícia Militar',
    habilitacoes: [
      {
        id: 'hab-007',
        areaInstrucao: 'Atendimento Pré-Hospitalar',
        cursoCfiId: 'cfi-007',
        validade: '2027-01-10',
        estado: 'ATIVA'
      }
    ],
    estado: 'ATIVO',
    avaliacaoMedia: 4.7,
    totalHorasMinistradas: 487,
    criadoEm: '2026-05-21T09:00:00Z'
  },
  {
    id: 'f87a8b23-149b-4395-8ef6-15e8d5f47004',
    servidorId: '768ea211-1a6c-48be-8a21-998dc711a004',
    matriculaPm: '101.234-5',
    nomeCompleto: '1º TEN QOPM RAFAEL COSTA',
    postoGraduacao: '1º TENENTE',
    unidadeNome: 'Batalhão de Operações Especiais',
    habilitacoes: [
      {
        id: 'hab-008',
        areaInstrucao: 'Tiro Policial',
        cursoCfiId: 'cfi-008',
        validade: '2025-06-30',
        estado: 'ATIVA'
      }
    ],
    estado: 'SUSPENSO',
    avaliacaoMedia: 4.6,
    totalHorasMinistradas: 421,
    criadoEm: '2026-05-22T14:20:00Z'
  },
  {
    id: 'f87a8b23-149b-4395-8ef6-15e8d5f47005',
    servidorId: '768ea211-1a6c-48be-8a21-998dc711a005',
    matriculaPm: '101.345-6',
    nomeCompleto: 'CAP QOPM MARCOS SILVA',
    postoGraduacao: 'CAPITÃO',
    unidadeNome: 'Batalhão de Choque',
    habilitacoes: [
      {
        id: 'hab-009',
        areaInstrucao: 'Defesa Pessoal',
        cursoCfiId: 'cfi-009',
        validade: '2026-05-15',
        estado: 'ATIVA'
      },
      {
        id: 'hab-010',
        areaInstrucao: 'Tiro Policial',
        cursoCfiId: 'cfi-010',
        validade: '2026-10-20',
        estado: 'ATIVA'
      }
    ],
    estado: 'ATIVO',
    avaliacaoMedia: 4.9,
    totalHorasMinistradas: 612,
    criadoEm: '2026-05-25T11:10:00Z'
  },
  {
    id: 'f87a8b23-149b-4395-8ef6-15e8d5f47006',
    servidorId: '768ea211-1a6c-48be-8a21-998dc711a006',
    matriculaPm: '102.567-1',
    nomeCompleto: '1º TEN QOPM ALINE SOUSA',
    postoGraduacao: '1º TENENTE',
    unidadeNome: 'DEC - Departamento de Ensino e Cultura',
    habilitacoes: [
      {
        id: 'hab-011',
        areaInstrucao: 'Gestão e Liderança',
        cursoCfiId: 'cfi-011',
        validade: '2026-11-30',
        estado: 'ATIVA'
      },
      {
        id: 'hab-012',
        areaInstrucao: 'Legislação',
        cursoCfiId: 'cfi-012',
        validade: '2026-02-28',
        estado: 'ATIVA'
      }
    ],
    estado: 'ATIVO',
    avaliacaoMedia: 4.8,
    totalHorasMinistradas: 398,
    criadoEm: '2026-05-26T09:15:00Z'
  }
];

export const MINHAS_ALOCACOES_MOCK: Alocacao[] = [
  {
    id: 'aloc-001',
    instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47001', // Lucas Ferreira
    turmaId: 'turma-tiro-iii',
    disciplina: 'Tiro Policial',
    alocadoEm: '2026-05-13T08:00:00Z'
  },
  {
    id: 'aloc-002',
    instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47001', // Lucas Ferreira
    turmaId: 'turma-aph-2024',
    disciplina: 'Suporte Básico de Vida (SBV)',
    alocadoEm: '2026-05-13T08:00:00Z'
  },
  {
    id: 'aloc-003',
    instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47001', // Lucas Ferreira
    turmaId: 'turma-defesa-2024',
    disciplina: 'Defesa Pessoal',
    alocadoEm: '2026-05-13T14:00:00Z'
  },
  {
    id: 'aloc-004',
    instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47001', // Lucas Ferreira
    turmaId: 'turma-aph-2024',
    disciplina: 'Atendimento em Trauma',
    alocadoEm: '2026-05-13T14:00:00Z'
  }
];

export const AVALIACOES_PENDENTES_MOCK: AvaliacaoPendenteResponse[] = [
  {
    turmaId: 'turma-cfi-111',
    nomeCurso: 'Curso de Formação de Instrutores - CFI',
    dataFimTurma: '2026-06-12',
    prazoFinal: '2026-06-19'
  },
  {
    turmaId: 'turma-its-222',
    nomeCurso: 'Instrução de Tiro para Sargentos - ITS',
    dataFimTurma: '2026-06-10',
    prazoFinal: '2026-06-17'
  }
];

export const PRODUTIVIDADE_RELATORIO_MOCK: ProdutividadeDocenteItem[] = [
  {
    instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47001',
    matriculaPm: '100.123-4',
    nomeCompleto: '1º TEN QOPM LUCAS FERREIRA',
    postoGraduacao: '1º TENENTE',
    totalHoras: 564,
    avaliacaoMedia: 4.9,
    turmasAtendidas: 12
  },
  {
    instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47005',
    matriculaPm: '101.345-6',
    nomeCompleto: 'CAP QOPM MARCOS SILVA',
    postoGraduacao: 'CAPITÃO',
    totalHoras: 612,
    avaliacaoMedia: 4.9,
    turmasAtendidas: 15
  },
  {
    instrutorId: 'f87a8b23-149b-4395-8ef6-15e8d5f47002',
    matriculaPm: '100.456-7',
    nomeCompleto: 'CAP QOPM BRUNO ALMEIDA',
    postoGraduacao: 'CAPITÃO',
    totalHoras: 512,
    avaliacaoMedia: 4.8,
    turmasAtendidas: 10
  }
];

export const WORKSPACE_KPIS_MOCK = {
  totalInstrutoresAtivos: 186,
  tendenciaAtivos: 8.2,
  horasMinistradasMes: 2458,
  tendenciaHoras: 12.4,
  avaliacaoMediaGlobal: 4.8,
  tendenciaGlobal: 0.2,
  turmasSemInstrutor: 7,
  tendenciaTurmas: -1
};

export const MOCK_TURMAS_CAPACITACAO = [
  {
    id: 'turma-tiro-iii',
    codigo: '2024/03',
    nome: 'Curso de Tiro Policial - Nível III',
    periodo: '20/05/2024 a 14/06/2024',
    vagas: '2/3',
    disciplinas: ['Instrução de Armamento', 'Tiro Prático', 'Tiro Noturno'],
    semInstrutorCount: 2,
    estado: 'PARCIAL'
  },
  {
    id: 'turma-aph-2024',
    codigo: '2024/02',
    nome: 'Curso de Atendimento Pré-Hospitalar',
    periodo: '15/05/2024 a 30/05/2024',
    vagas: '1/2',
    disciplinas: ['Suporte Básico de Vida (SBV)', 'Atendimento em Trauma'],
    semInstrutorCount: 1,
    estado: 'PARCIAL'
  },
  {
    id: 'turma-defesa-2024',
    codigo: '2024/04',
    nome: 'Curso de Defesa Pessoal Policial',
    periodo: '10/06/2024 a 28/06/2024',
    vagas: '0/2',
    disciplinas: ['Táticas de Imobilização', 'Combate Corpo a Corpo'],
    semInstrutorCount: 0,
    estado: 'COMPLETA'
  },
  {
    id: 'turma-legis-2024',
    codigo: '2024/01',
    nome: 'Curso de Legislação Policial',
    periodo: '01/05/2024 a 22/05/2024',
    vagas: '0/1',
    disciplinas: ['Direito Militar Aplicado'],
    semInstrutorCount: 0,
    estado: 'COMPLETA'
  }
];
